import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { Hero } from '@/components/Hero';
import { FeaturedTournaments } from '@/components/FeaturedTournaments';
import { Pilares } from '@/components/Pilares';
import { ClubesDaPlataforma } from '@/components/ClubesDaPlataforma';
import { Comunidade } from '@/components/Comunidade';
import { GaleriaDeCampeoes } from '@/components/GaleriaDeCampeoes';
import { queries, type TournamentSummary } from '@/lib/api';

export function HomePage() {
  const { data, isLoading } = useQuery(queries.tournaments('registration'));

  const featured: TournamentSummary[] = (data?.tournaments ?? [])
    .slice()
    .sort((a, b) => (a.startsAt ?? Infinity) - (b.startsAt ?? Infinity));

  return (
    <>
      {/*
        A hero ocupa uma tela e sai de cena rolando, como qualquer seção.

        Havia aqui um palco de 260vh cuja única função era dar corda ao vídeo:
        a hero ficava grudada no topo e os quadros avançavam conforme a página
        rolava. Custava duas telas e meia de rolagem para entregar quatro
        segundos de imagem, e quem chegava e não rolava via uma foto parada. A
        jogada agora roda sozinha na abertura, então o palco perdeu a razão de
        existir — e a página voltou a ter altura honesta.
      */}
      <Hero featured={featured} loading={isLoading} />

      {/* `bg-ink` não é decorativo: garante fundo opaco sobre a hero. */}
      <div className="relative z-10 bg-ink">
        {/* Torneios com Inscrições Abertas */}
        <FeaturedTournaments tournaments={featured} loading={isLoading} />

        <GaleriaDeCampeoes />

        <ClubesDaPlataforma />

        <Pilares />

        <Comunidade />

      {/* CTA Final */}
      <section className="relative z-10 border-t border-line bg-void py-20">
        <div className="mx-auto max-w-4xl px-6 text-center">
          <h2 className="ucc-display text-3xl text-paper md:text-5xl">
            Pronto para colocar sua equipe no topo?
          </h2>
          <p className="mt-4 text-base text-muted md:text-lg">
            Reúna seu elenco, escolha o campeonato e dispute o título com os melhores times do cenário.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link
              to="/campeonatos"
              className="rounded-lg bg-gold px-8 py-3.5 font-semibold text-black uppercase transition-all duration-[--duration-quick] hover:bg-gold-bright hover:shadow-[var(--shadow-gold)]"
            >
              Ver Campeonatos Abertos
            </Link>
            <Link
              to="/regulamento"
              className="rounded-lg border border-line-strong bg-surface px-8 py-3.5 font-semibold text-paper uppercase transition-colors duration-[--duration-quick] hover:border-gold/40 hover:bg-surface-2"
            >
              Ler Regulamento
            </Link>
          </div>
        </div>
      </section>
      </div>
    </>
  );
}

